import type { PropsWithChildren } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { WalletConnectStateContext } from './context';
import { useAutoConnect, useDisconnect } from './hooks';
import type { WalletConnectState } from './types';

export const WalletConnectStateProvider = ({
  chains,
  wallets,
  children,
}: PropsWithChildren<Pick<WalletConnectState, 'chains' | 'wallets'>>) => {
  const { disconnectAsync } = useDisconnect();

  const [isReconnecting, setIsReconnecting] = useState(true);

  const handleReconnectComplete = useCallback(() => setIsReconnecting(false), []);

  const contextValue = useMemo(
    () => ({
      chains,
      wallets,
      isReconnecting,
      disconnectAsync,
    }),
    [chains, wallets, isReconnecting, disconnectAsync],
  );

  useAutoConnect(wallets, chains, handleReconnectComplete);

  return <WalletConnectStateContext.Provider value={contextValue}>{children}</WalletConnectStateContext.Provider>;
};
